import _objectSpread from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "TUI-contact-list"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  "class": "TUI-contact-list-item-header-left"
};
var _hoisted_4 = {
  "class": "TUI-contact-list-item-header-right"
};
var _hoisted_5 = {
  key: 0,
  "class": "TUI-contact-list-item-header-right-unread"
};
var _hoisted_6 = {
  key: 0,
  "class": "TUI-contact-list-item-main"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  key: 1,
  "class": "TUI-contact-list"
};
var _hoisted_9 = {
  key: 0,
  "class": "TUI-contact-search-list"
};
var _hoisted_10 = {
  "class": "TUI-contact-search-list-title"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  key: 0,
  "class": "TUI-contact-search-list-default"
};
import { TUITranslateService, TUIStore, StoreName, TUIFriendService, TUIUserService } from "@tencentcloud/chat-uikit-engine";
import TUICore, { TUIConstants } from "@tencentcloud/tui-core";
import { ref, computed, onMounted, onUnmounted } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import downSVG from "../../../assets/icon/down-icon.svg";
import rightSVG from "../../../assets/icon/right-icon.svg";
import ContactListItem from "./contact-list-item/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var currentContactListKey = ref("");
    var currentContactInfo = ref({});
    var contactListMap = ref({
      friendApplicationList: {
        key: 'friendApplicationList',
        title: "新的联系人",
        list: [],
        unreadCount: 0
      },
      blackList: {
        key: 'blackList',
        title: "黑名单",
        list: []
      },
      groupList: {
        key: 'groupList',
        title: "我的群聊",
        list: []
      },
      friendList: {
        key: 'friendList',
        title: "我的好友",
        list: []
      }
    });
    var contactSearchingStatus = ref(false);
    var contactSearchResult = ref();
    var displayOnlineStatus = ref(false);
    var userOnlineStatusMap = ref();
    var isContactSearchNoResult = computed(function () {
      var _contactSearchResult$, _contactSearchResult$2;
      return !(contactSearchResult !== null && contactSearchResult !== void 0 && (_contactSearchResult$ = contactSearchResult.value) !== null && _contactSearchResult$ !== void 0 && (_contactSearchResult$ = _contactSearchResult$.user) !== null && _contactSearchResult$ !== void 0 && _contactSearchResult$.list[0]) && !(contactSearchResult !== null && contactSearchResult !== void 0 && (_contactSearchResult$2 = contactSearchResult.value) !== null && _contactSearchResult$2 !== void 0 && (_contactSearchResult$2 = _contactSearchResult$2.group) !== null && _contactSearchResult$2 !== void 0 && _contactSearchResult$2.list[0]);
    });
    onMounted(function () {
      TUIStore.watch(StoreName.APP, {
        enabledCustomerServicePlugin: onCustomerServiceCommercialPluginUpdated
      });
      TUIStore.watch(StoreName.GRP, {
        groupList: onGroupListUpdated
      });
      TUIStore.watch(StoreName.USER, {
        userBlacklist: onUserBlacklistUpdated,
        displayOnlineStatus: onDisplayOnlineStatusUpdated,
        userStatusList: onUserStatusListUpdated
      });
      TUIStore.watch(StoreName.FRIEND, {
        friendList: onFriendListUpdated,
        friendApplicationList: onFriendApplicationListUpdated,
        friendApplicationUnreadCount: onFriendApplicationUnreadCountUpdated
      });
      TUIStore.watch(StoreName.CUSTOM, {
        currentContactSearchingStatus: onCurrentContactSearchingStatusUpdated,
        currentContactSearchResult: onCurrentContactSearchResultUpdated
      });
    });
    onUnmounted(function () {
      TUIStore.unwatch(StoreName.APP, {
        enabledCustomerServicePlugin: onCustomerServiceCommercialPluginUpdated
      });
      TUIStore.unwatch(StoreName.GRP, {
        groupList: onGroupListUpdated
      });
      TUIStore.unwatch(StoreName.USER, {
        userBlacklist: onUserBlacklistUpdated,
        displayOnlineStatus: onDisplayOnlineStatusUpdated,
        userStatusList: onUserStatusListUpdated
      });
      TUIStore.unwatch(StoreName.FRIEND, {
        friendList: onFriendListUpdated,
        friendApplicationList: onFriendApplicationListUpdated,
        friendApplicationUnreadCount: onFriendApplicationUnreadCountUpdated
      });
      TUIStore.unwatch(StoreName.CUSTOM, {
        currentContactSearchingStatus: onCurrentContactSearchingStatusUpdated,
        currentContactSearchResult: onCurrentContactSearchResultUpdated
      });
    });
    function updateCurrentContactInfoFromList(list, type) {
      var _currentContactInfo$v, _currentContactInfo$v2, _currentContactInfo$v3, _currentContactInfo$v5;
      if (!(currentContactInfo !== null && currentContactInfo !== void 0 && (_currentContactInfo$v = currentContactInfo.value) !== null && _currentContactInfo$v !== void 0 && _currentContactInfo$v.userID) && !(currentContactInfo !== null && currentContactInfo !== void 0 && (_currentContactInfo$v2 = currentContactInfo.value) !== null && _currentContactInfo$v2 !== void 0 && _currentContactInfo$v2.groupID)) {
        return;
      } else if (currentContactInfo !== null && currentContactInfo !== void 0 && (_currentContactInfo$v3 = currentContactInfo.value) !== null && _currentContactInfo$v3 !== void 0 && _currentContactInfo$v3.groupID && (type === currentContactListKey.value || contactSearchingStatus.value)) {
        currentContactInfo.value = list === null || list === void 0 ? void 0 : list.find(function (item) {
          var _currentContactInfo$v4;
          return (item === null || item === void 0 ? void 0 : item.groupID) && (item === null || item === void 0 ? void 0 : item.groupID) === (currentContactInfo === null || currentContactInfo === void 0 || (_currentContactInfo$v4 = currentContactInfo.value) === null || _currentContactInfo$v4 === void 0 ? void 0 : _currentContactInfo$v4.groupID);
        });
        TUIStore.update(StoreName.CUSTOM, "currentContactInfo", currentContactInfo.value);
      } else if (currentContactInfo !== null && currentContactInfo !== void 0 && (_currentContactInfo$v5 = currentContactInfo.value) !== null && _currentContactInfo$v5 !== void 0 && _currentContactInfo$v5.userID && (type === currentContactListKey.value || contactSearchingStatus.value)) {
        currentContactInfo.value = list === null || list === void 0 ? void 0 : list.find(function (item) {
          var _currentContactInfo$v6;
          return (item === null || item === void 0 ? void 0 : item.userID) && (item === null || item === void 0 ? void 0 : item.userID) === (currentContactInfo === null || currentContactInfo === void 0 || (_currentContactInfo$v6 = currentContactInfo.value) === null || _currentContactInfo$v6 === void 0 ? void 0 : _currentContactInfo$v6.userID);
        });
        TUIStore.update(StoreName.CUSTOM, "currentContactInfo", currentContactInfo.value);
      }
    }
    function toggleCurrentContactList(key) {
      if (currentContactListKey.value === key) {
        currentContactListKey.value = "";
        currentContactInfo.value = {};
        TUIStore.update(StoreName.CUSTOM, "currentContactInfo", currentContactInfo.value);
      } else {
        currentContactListKey.value = key;
        if (key === "friendApplicationList") {
          TUIFriendService.setFriendApplicationRead();
        }
      }
    }
    function selectItem(item) {
      currentContactInfo.value = item;
      // 单独处理：
      // 对于 搜索列表 中 某结果，查看 contactInfo 详情前，需要对于“已在群组列表/已在好友列表” 的情况进行数据更新，已获得更详细的信息
      if (contactSearchingStatus.value) {
        var _currentContactInfo$v7, _currentContactInfo$v9;
        var targetListItem;
        if (currentContactInfo !== null && currentContactInfo !== void 0 && (_currentContactInfo$v7 = currentContactInfo.value) !== null && _currentContactInfo$v7 !== void 0 && _currentContactInfo$v7.userID) {
          var _contactListMap$value;
          targetListItem = contactListMap === null || contactListMap === void 0 || (_contactListMap$value = contactListMap.value) === null || _contactListMap$value === void 0 || (_contactListMap$value = _contactListMap$value.friendList) === null || _contactListMap$value === void 0 || (_contactListMap$value = _contactListMap$value.list) === null || _contactListMap$value === void 0 ? void 0 : _contactListMap$value.find(function (item) {
            var _currentContactInfo$v8;
            return (item === null || item === void 0 ? void 0 : item.userID) === (currentContactInfo === null || currentContactInfo === void 0 || (_currentContactInfo$v8 = currentContactInfo.value) === null || _currentContactInfo$v8 === void 0 ? void 0 : _currentContactInfo$v8.userID);
          });
        } else if (currentContactInfo !== null && currentContactInfo !== void 0 && (_currentContactInfo$v9 = currentContactInfo.value) !== null && _currentContactInfo$v9 !== void 0 && _currentContactInfo$v9.groupID) {
          var _contactListMap$value2;
          targetListItem = contactListMap === null || contactListMap === void 0 || (_contactListMap$value2 = contactListMap.value) === null || _contactListMap$value2 === void 0 || (_contactListMap$value2 = _contactListMap$value2.groupList) === null || _contactListMap$value2 === void 0 || (_contactListMap$value2 = _contactListMap$value2.list) === null || _contactListMap$value2 === void 0 ? void 0 : _contactListMap$value2.find(function (item) {
            var _currentContactInfo$v10;
            return (item === null || item === void 0 ? void 0 : item.groupID) === (currentContactInfo === null || currentContactInfo === void 0 || (_currentContactInfo$v10 = currentContactInfo.value) === null || _currentContactInfo$v10 === void 0 ? void 0 : _currentContactInfo$v10.groupID);
          });
        }
        if (targetListItem) {
          currentContactInfo.value = targetListItem;
        }
      }
      // 更新数据
      TUIStore.update(StoreName.CUSTOM, "currentContactInfo", currentContactInfo.value);
    }
    function onDisplayOnlineStatusUpdated(status) {
      displayOnlineStatus.value = status;
    }
    function onUserStatusListUpdated(list) {
      if ((list === null || list === void 0 ? void 0 : list.size) > 0) {
        userOnlineStatusMap.value = Object.fromEntries(list === null || list === void 0 ? void 0 : list.entries());
      }
    }
    function onCustomerServiceCommercialPluginUpdated(isEnabled) {
      if (!isEnabled) {
        return;
      }
      /// 客户购买客服插件后 engine 通过商业化能力位更新将 enabledCustomerServicePlugin 设置为 true
      var contactListExtensionID = TUIConstants.TUIContact.EXTENSION.CONTACT_LIST.EXT_ID;
      var tuiContactExtensionList = TUICore.getExtensionList(contactListExtensionID);
      var customerData = tuiContactExtensionList.find(function (extension) {
        var _ref = extension.data || {},
          name = _ref.name,
          _ref$accountList = _ref.accountList,
          accountList = _ref$accountList === void 0 ? [] : _ref$accountList;
        return name === 'customer' && accountList.length > 0;
      });
      if (customerData) {
        var data = customerData.data,
          text = customerData.text;
        var _ref2 = data || {},
          accountList = _ref2.accountList;
        TUIUserService.getUserProfile({
          userIDList: accountList
        }).then(function (res) {
          if (res.data.length > 0) {
            var customerList = {
              title: text,
              list: res.data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  infoKeyList: [],
                  btnKeyList: ["enterC2CConversation"]
                });
              }),
              key: "customerList"
            };
            contactListMap.value = _objectSpread(_objectSpread({}, contactListMap.value), {}, {
              customerList: customerList
            });
          }
        })["catch"](function () {});
      }
    }
    function onGroupListUpdated(groupList) {
      contactListMap.value.groupList.list = groupList;
      updateCurrentContactInfoFromList(contactListMap.value.groupList.list, "groupList");
    }
    function onUserBlacklistUpdated(userBlacklist) {
      contactListMap.value.blackList.list = userBlacklist;
      updateCurrentContactInfoFromList(contactListMap.value.blackList.list, "blackList");
    }
    function onFriendApplicationUnreadCountUpdated(friendApplicationUnreadCount) {
      contactListMap.value.friendApplicationList.unreadCount = friendApplicationUnreadCount;
    }
    function onFriendListUpdated(friendList) {
      contactListMap.value.friendList.list = friendList;
      updateCurrentContactInfoFromList(contactListMap.value.friendList.list, "friendList");
    }
    function onFriendApplicationListUpdated(friendApplicationList) {
      contactListMap.value.friendApplicationList.list = friendApplicationList;
      updateCurrentContactInfoFromList(contactListMap.value.friendApplicationList.list, "friendApplicationList");
    }
    function onCurrentContactSearchResultUpdated(searchResult) {
      contactSearchResult.value = searchResult;
    }
    function onCurrentContactSearchingStatusUpdated(searchingStatus) {
      contactSearchingStatus.value = searchingStatus;
      currentContactInfo.value = {};
      currentContactListKey.value = "";
      TUIStore.update(StoreName.CUSTOM, "currentContactInfo", currentContactInfo.value);
    }
    return function (_ctx, _cache) {
      return !_unref(contactSearchingStatus) ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactListMap), function (contactListObj, key) {
        return _openBlock(), _createElementBlock("li", {
          "class": "TUI-contact-list-item",
          key: key
        }, [_createElementVNode("header", {
          "class": "TUI-contact-list-item-header",
          onClick: function onClick($event) {
            return toggleCurrentContactList(key);
          }
        }, [_createElementVNode("div", _hoisted_3, [_createVNode(Icon, {
          file: _unref(currentContactListKey) === key ? _unref(downSVG) : _unref(rightSVG),
          width: "16px",
          height: "16px"
        }, null, 8, ["file"]), _createElementVNode("div", null, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(contactListObj.title))), 1)]), _createElementVNode("div", _hoisted_4, [contactListObj.unreadCount ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(contactListObj.unreadCount), 1)) : _createCommentVNode("", true)])], 8, _hoisted_2), _unref(currentContactListKey) === key ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactListObj.list, function (contactListItem, contactListItemKey) {
          return _openBlock(), _createElementBlock("li", {
            key: contactListItemKey,
            "class": _normalizeClass(["TUI-contact-list-item-main-item", ['selected']]),
            onClick: function onClick($event) {
              return selectItem(contactListItem);
            }
          }, [_createVNode(ContactListItem, {
            item: contactListItem,
            list: contactListObj.list,
            displayOnlineStatus: contactListObj.key === 'friendList' && _unref(displayOnlineStatus),
            userOnlineStatusMap: _unref(userOnlineStatusMap)
          }, null, 8, ["item", "list", "displayOnlineStatus", "userOnlineStatusMap"])], 8, _hoisted_7);
        }), 128))])) : _createCommentVNode("", true)]);
      }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactSearchResult), function (item, key) {
        return _openBlock(), _createElementBlock("li", {
          "class": "TUI-contact-list-item",
          key: key
        }, [item.list[0] ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(item.label))), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, function (listItem) {
          return _openBlock(), _createElementBlock("div", {
            "class": _normalizeClass(["TUI-contact-search-list-item", ['selected']]),
            onClick: function onClick($event) {
              return selectItem(listItem);
            }
          }, [_createVNode(ContactListItem, {
            item: listItem,
            list: item.list
          }, null, 8, ["item", "list"])], 8, _hoisted_11);
        }), 256))])) : _createCommentVNode("", true)]);
      }), 128)), _unref(isContactSearchNoResult) ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(TUITranslateService).t("TUIContact.无搜索结果")), 1)) : _createCommentVNode("", true)]));
    };
  }
});